<div class="modal-header">
  <rask-header size="2">{{ getHeader() }}</rask-header>

  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<rask-container-block>
  @if (arbetsorder.warnings?.length > 0) {
    <div>
      @for (message of arbetsorder.warnings; track message) {
        <div>
          <rask-validation-message-row [type]="message.type" [message]="message.long">
          </rask-validation-message-row>
        </div>
      }
    </div>
  }
  <ng-container footer>
    <rask-button color="primary" (click)="close()">{{ 'DIALOGS_CLOSE' | translate }}</rask-button>
  </ng-container>
</rask-container-block>